import { FC, useState } from 'react'

import { Box, Button, CircularProgress, ListSubheader, Typography } from '@mui/material'
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { getEstimateItems, getEstimateItemsGroupBy } from 'src/ducks/estimateItems/selectors'
import { Item } from 'src/ducks/types'
import { ESTIMATE_VIEW, ITEM_CATEGORY, ITEM_CATEGORY_FOR_FILTERS, ITEM_PRIORITY, ITEM_STATUS, round, sortItemsByCategories } from 'src/helpers/index'
import EstimateItem from '../EstimateItem'
import EstimateItemsContainer from '../EstimateItemsContainer'
import useStyles from './styles'

export interface EstimatedItemsProps {
  selectedType: ESTIMATE_VIEW
  hideRemoved: boolean
  selectedFilt: ITEM_CATEGORY_FOR_FILTERS | ITEM_PRIORITY
  fetchEstimateView: (loadings: boolean) => void
  handleShowAlert: (Item: Item) => void
  punchlistPlanner: boolean
  estimateNotApproved: boolean
  getIcon: (item: string, color?: string) => JSX.Element
  serviceable?: boolean
}

const EstimatedItems: FC<EstimatedItemsProps> = ({ selectedType, hideRemoved, serviceable, selectedFilt, fetchEstimateView, handleShowAlert, punchlistPlanner, estimateNotApproved, getIcon }) => {
  const classes = useStyles()

  const [expandAll, setExpandAll] = useState(false)
  const [loading] = useState(false)
  const [loadingAll] = useState(false)

  const [itemIdLoading] = useState('')

  const estimateItems = useSelector(getEstimateItems(false)).filter((item: Item) => {
    return !item.addedPostDelivery || (item.addedPostDelivery && item.status !== ITEM_STATUS.NEW)
  })

  const groupedItems = sortItemsByCategories(useSelector(
    getEstimateItemsGroupBy(selectedType, hideRemoved, selectedFilt !== ITEM_CATEGORY_FOR_FILTERS.ALL ? selectedFilt : undefined, undefined, estimateItems)
  ))

  delete groupedItems.EVALUATE

  if (isEmpty(groupedItems)) return <></>

  return (
    <EstimateItemsContainer
      groupedItems={groupedItems}
      title="ESTIMATED ITEMS"
      action={
        <>
          <Button
            onClick={() => setExpandAll(!expandAll)}
            variant='text'
            className={classes.expandButton}
          >
            {expandAll ? 'Collapse' : 'Expand'} All Items
          </Button>
          {/* {estimateNotApproved && <Button
            onClick={() => showRemoveAll ? handleRemoveItems() : handleAddItems()}
            variant='text'
            className={`${showRemoveAll ? classes.removeAllButton : classes.addAllButton}`}
            startIcon={!showRemoveAll ? (<icons.ShoppingCart />) : <></>}
            // disabled={loading || itemsToBatch.length === 0}
            disabled={true}
          >
            {showRemoveAll ? 'Remove All Items' : 'Add All Items'}
          </Button>} */}
        </>

      }
    >
      {Object.keys(groupedItems).map((itemKey) => {
        const items = groupedItems[itemKey]
        const itemCategory =
          selectedType === ESTIMATE_VIEW.TYPE
            ? ITEM_CATEGORY[itemKey as keyof typeof ITEM_CATEGORY]
            : itemKey

        const itemSubtotal = (items as Item[]).reduce((acc, item) => item.status === ITEM_STATUS.APPROVED ? acc + item.unitPrice * Number(item.quantity) : acc, 0)

        return (
          <Box className={classes.categoryContainer} key={itemKey}>
            <ListSubheader className={classes.subHeader}>
              <Box className={classes.categoryHeader}>
                {getIcon(itemKey, 'var(--bosscat-blue-600)')}
                <Typography className={classes.categoryTitle}>
                  {itemCategory}
                </Typography>
                <Typography className={classes.categoryTitle}>
                  {'- $' + round(itemSubtotal, 2)}
                </Typography>
              </Box>
            </ListSubheader>

            {items.map((item: Item, index: number) => {
              return (
                <Box key={item.itemId} /* className={itemCategory === ITEM_CATEGORY.EVALUATE ? classes.evaluateContainer : ''} */>
                  <EstimateItem
                    item={item}
                    // showAlert={() => handleShowAlert && handleShowAlert(item)}
                    isPunchlistPlanner={punchlistPlanner}
                    initialOpen={expandAll}
                    showPrice={item.category !== ITEM_CATEGORY.EXCLUDED.toUpperCase()}
                    // showPriceRange={!serviceable}
                    actions={
                      estimateNotApproved ?
                        <>
                          {(loading && item.itemId === itemIdLoading) || loadingAll ?
                            <Box width={86} className={classes.spinnerContainer}>
                              <CircularProgress />
                            </Box>
                            :
                            <></>
                            // (item.category === ITEM_CATEGORY.EXCLUDED.toUpperCase()) ?
                            //   <></> :
                            //   <Button
                            //     startIcon={
                            //       !itemIsInCart && <icons.ShoppingCart />
                            //     }
                            //     onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                            //       event.stopPropagation()
                            //       // handleUpdateItem(item)
                            //       // handleClickConsultation(item)
                            //     }}
                            //     // disabled={loading}
                            //     disabled={true}
                            //     className={itemIsInCart ? classes.buttonRemove : classes.buttonAdd}>
                            //     {itemIsInCart ? 'Remove' : 'Add'}
                            //   </Button>
                          }
                        </>
                        : <></>
                    }
                  />
                </Box>
              )
            })}
          </Box>
        )
      })}
    </EstimateItemsContainer>
  )
}

export default EstimatedItems
